import models from './model-storage';

const e = {
    models,
};

window.zustand = e;

export default { models };
